import React from "react";
import { Box, Typography } from "@mui/material";
import { KPICarousel, KPICard } from "../../../Components/KPICarousel";

// ─── Temporary KPI data (replace with API call when backend is ready) ─────────
const kpiData = [
  {
    title: "Vehicle Utilisation Rate (%)",
    titleTooltip: "Percentage of fleet vehicles actively utilised (discharging) during the selected period.",
    value: "86 %",
    previousValue: "82 %",
    trend: "up",
    isPositive: true,
    trendValue: "4%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Operating Hrs. per Vehicle", value: "12 h" },
      { label: "Avg Drive Time per Vehicle", value: "8.7 h" },
    ],
  },
  {
    title: "Idle Time Ratio (%)",
    titleTooltip: "Percentage of total time vehicles spent idle (powered on but not driving or charging).",
    value: "18 %",
    previousValue: "22 %",
    trend: "down",
    isPositive: true,
    trendValue: "4%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Avg Idle Duration per Event", value: "34 min" },
      { label: "Total Idle Hours (Fleet)", value: "1,248 h" },
    ],
  },
  {
    title: "Offline Rate (%)",
    titleTooltip: "Percentage of time vehicles had no data reported, indicating connectivity issues or planned downtime.",
    value: "6 %",
    previousValue: "9 %",
    trend: "down",
    isPositive: true,
    trendValue: "3%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Avg Consecutive Offline Duration", value: "1.8 h" },
      { label: "Vehicles Offline Today", value: "42" },
    ],
  },
  {
    title: "Charging Time Ratio (%)",
    titleTooltip: "Percentage of total time vehicles spent in a charging state across the fleet.",
    value: "23 %",
    previousValue: "21 %",
    trend: "up",
    isPositive: false,
    trendValue: "2%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Avg Charge Duration (Fast)", value: "48 min" },
      { label: "Avg Charge Duration (Slow)", value: "3.2 h" },
    ],
  },
  {
    title: "Fast vs. Slow Charge Ratio (%)",
    titleTooltip: "Share of charging sessions using fast charging vs. slow charging across the fleet.",
    value: "62 %",
    previousValue: "57 %",
    trend: "up",
    isPositive: true,
    trendValue: "5%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Fast Charge Sessions", value: "3,844" },
      { label: "Slow Charge Sessions", value: "2,356" },
    ],
  },
  {
    title: "Charging Efficiency (%)",
    titleTooltip: "Ratio of actual charge energy consumed to ideal charging energy. Lower values indicate charging losses.",
    value: "91 %",
    previousValue: "89 %",
    trend: "up",
    isPositive: true,
    trendValue: "2%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Avg Energy Consumed per Charge", value: "28.4 kWh" },
      { label: "Avg Ideal Charge Energy", value: "31.2 kWh" },
    ],
  },
  {
    title: "Avg SOC at Charge Start (%)",
    titleTooltip: "Average battery state of charge when a charging session is initiated. Very low values indicate range anxiety; very high values indicate inefficient charging habits.",
    value: "34 %",
    previousValue: "31 %",
    trend: "up",
    isPositive: true,
    trendValue: "3%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Avg SOC at Charge End", value: "88 %" },
      { label: "Avg SOC Delta per Session", value: "54 %" },
    ],
  },
];

// ─── Component ─────────────────────────────────────────────────────────────────
const UtilizationKPISection = ({ vehiclesConnected, showHeader = true }) => {
  const renderKPICard = (kpi) => (
    <KPICard
      title={kpi.title}
      titleTooltip={kpi.titleTooltip}
      value={kpi.value}
      previousValue={kpi.previousValue}
      trend={kpi.trend}
      isPositive={kpi.isPositive}
      trendValue={kpi.trendValue}
      trendPeriod={kpi.trendPeriod}
      metrics={kpi.metrics}
      totalVehicles={vehiclesConnected}
    />
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      {showHeader && (
        <Box>
          <Typography
            variant="fw400s20c000"
            sx={{ lineHeight: "28px", fontWeight: 300 }}
          >
            Key Performance Indicators
          </Typography>
        </Box>
      )}
      <KPICarousel
        data={kpiData}
        renderCard={renderKPICard}
      />
    </Box>
  );
};

export default UtilizationKPISection;
